function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "CheckboxON_Blue",
  transform: "translate(-7598.5 -10579)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_205",
  className: "background",
  "data-name": "Rectangle 205",
  transform: "translate(7598.5 10579)",
  fill: "#304ffe",
  stroke: "#304ffe",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 18,
  height: 18,
  rx: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_159",
  className: "check",
  "data-name": "Path 159",
  d: "M7603.818 10589.249l3.277 4.475 6.884-9.4",
  fill: "none",
  stroke: "#f2f7fa",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 3
}));

function SvgCheckboxTrue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTrue);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8ZyBpZD0iQ2hlY2tib3hPTl9CbHVlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzU5OC41IC0xMDU3OSkiPgogICAgPGcgaWQ9IlJlY3RhbmdsZV8yMDUiIGNsYXNzPSJiYWNrZ3JvdW5kIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyMDUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc1OTguNSAxMDU3OSkiIGZpbGw9IiMzMDRmZmUiIHN0cm9rZT0iIzMwNGZmZSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNSIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjQiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJQYXRoXzE1OSIgY2xhc3M9ImNoZWNrIiBkYXRhLW5hbWU9IlBhdGggMTU5IiBkPSJNMTIxNy4zNjEsNTIuNDE2bDMuMjc3LDQuNDc1LDYuODg0LTkuNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjM4Ni40NTcgMTA1MzYuODMzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZjJmN2ZhIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };